(() => {
  const selector =
    '[data-proxium-demo-escala]';

  const PAGE_COUNT = 5;
  const DASHBOARD_WIDTH = 1200;
  const DASHBOARD_HEIGHT = 900;

  function init(root) {
    if (
      !root ||
      root.dataset.proxiumReady ===
        'true'
    ) {
      return;
    }

    root.dataset.proxiumReady =
      'true';

    const listeners = [];
    const timers = [];

    let currentPage = 0;
    let demoRevealed = false;

    const on = (
      target,
      event,
      handler,
      options
    ) => {
      if (!target) {
        return;
      }

      target.addEventListener(
        event,
        handler,
        options
      );

      listeners.push(() => {
        target.removeEventListener(
          event,
          handler,
          options
        );
      });
    };

    const frames = () => [
      ...root.querySelectorAll(
        '.monitor iframe'
      )
    ];

    const dashboardFrame =
      root.querySelector(
        '.js-dashboard-frame'
      );

    const phone =
      root.querySelector(
        '.phone.phone--v2'
      );

    const setPhoneVisible = (
      visible
    ) => {
      if (!phone) {
        return;
      }

      phone.classList.toggle(
        'is-visible',
        visible
      );

      phone.setAttribute(
        'aria-hidden',
        visible
          ? 'false'
          : 'true'
      );
    };

    const revealDemo = () => {
      if (demoRevealed) {
        return;
      }

      demoRevealed = true;

      window.requestAnimationFrame(
        () => {
          window.requestAnimationFrame(
            () => {
              if (dashboardFrame) {
                dashboardFrame.setAttribute(
                  'aria-busy',
                  'false'
                );
              }

              root.classList.remove(
                'is-loading'
              );

              root.classList.add(
                'is-ready'
              );
            }
          );
        }
      );
    };

    const openDashboardPage = (
      frame,
      index
    ) => {
      try {
        if (
          typeof frame.contentWindow
            ?.showDashboardPage ===
          'function'
        ) {
          frame.contentWindow
            .showDashboardPage(index);

          return true;
        }

        const button =
          frame.contentDocument
            ?.querySelectorAll(
              '.navbtn'
            )
            ?.[index];

        if (!button) {
          return false;
        }

        button.click();

        return true;
      } catch (error) {
        return false;
      }
    };

    const fit = () => {
      const hero =
        root.querySelector(
          '.hero-shell'
        );

      const stage =
        root.querySelector(
          '.js-stage'
        );

      if (
        hero &&
        stage &&
        window.innerWidth > 749
      ) {
        const scale = Math.min(
          hero.clientWidth / 1200,
          hero.clientHeight / 900
        );

        stage.style.setProperty(
          '--fit',
          String(scale)
        );
      }

      root
        .querySelectorAll('.screen')
        .forEach((screen) => {
          const frame =
            screen.querySelector(
              'iframe'
            );

          if (!frame) {
            return;
          }

          const scale = Math.min(
            screen.clientWidth /
              DASHBOARD_WIDTH,
            screen.clientHeight /
              DASHBOARD_HEIGHT
          );

          frame.style.setProperty(
            '--screen-fit',
            String(scale)
          );
        });
    };

    const setActive = (index) => {
      currentPage =
        (
          index +
          PAGE_COUNT
        ) %
        PAGE_COUNT;

      const navPages =
        root.querySelector(
          '.nav-pages'
        );

      root
        .querySelectorAll(
          '.page-btn'
        )
        .forEach(
          (
            button,
            buttonIndex
          ) => {
            const active =
              buttonIndex ===
              currentPage;

            button.classList.toggle(
              'active',
              active
            );

            button.setAttribute(
              'aria-current',
              active
                ? 'page'
                : 'false'
            );

            if (
              active &&
              navPages
            ) {
              const target =
                button.offsetLeft -
                (
                  navPages.clientWidth -
                  button.offsetWidth
                ) /
                  2;

              navPages.scrollTo({
                left:Math.max(
                  0,
                  target
                ),
                behavior:'smooth'
              });
            }
          }
        );
    };

    const go = (index) => {
      const target =
        (
          index +
          PAGE_COUNT
        ) %
        PAGE_COUNT;

      setPhoneVisible(false);
      setActive(target);

      frames().forEach(
        (frame) => {
          const apply = () =>
            openDashboardPage(
              frame,
              target
            );

          if (!apply()) {
            on(
              frame,
              'load',
              apply,
              {
                once:true
              }
            );
          }
        }
      );
    };

    root
      .querySelectorAll(
        '[data-dashboard-page]'
      )
      .forEach((button) => {
        on(
          button,
          'click',
          () => {
            go(
              Number(
                button.dataset
                  .dashboardPage ||
                  0
              )
            );
          }
        );
      });

    root
      .querySelectorAll(
        '[data-dashboard-action]'
      )
      .forEach((button) => {
        on(
          button,
          'click',
          () => {
            const direction =
              button.dataset
                .dashboardAction ===
              'prev'
                ? -1
                : 1;

            go(
              currentPage +
                direction
            );
          }
        );
      });

    const animateAppSheet =
      () => {
        const button =
          root.querySelector(
            '.js-appsheet-save'
          );

        const pill =
          root.querySelector(
            '.js-sync-pill'
          );

        if (
          !button ||
          !pill ||
          button.classList.contains(
            'syncing'
          )
        ) {
          return;
        }

        const defaultLabel =
          button.dataset
            .defaultLabel ||
          'Guardar movimiento';

        button.classList.add(
          'syncing'
        );

        button.textContent =
          'Guardando…';

        timers.push(
          window.setTimeout(
            () => {
              button.classList.remove(
                'syncing'
              );

              button.classList.add(
                'saved'
              );

              button.textContent =
                '✓ Guardado';

              pill.classList.add(
                'show'
              );
            },
            750
          )
        );

        timers.push(
          window.setTimeout(
            () => {
              pill.classList.remove(
                'show'
              );

              button.classList.remove(
                'saved'
              );

              button.textContent =
                defaultLabel;

              setPhoneVisible(false);
            },
            2800
          )
        );
      };

    on(
      root.querySelector(
        '.js-appsheet-save'
      ),
      'click',
      animateAppSheet
    );

    on(
      root.querySelector(
        '[data-close-appsheet]'
      ),
      'click',
      () => {
        setPhoneVisible(false);
      }
    );

    const handleMessage = (
      event
    ) => {
      const validSource =
        frames().some(
          (frame) =>
            frame.contentWindow ===
            event.source
        );

      if (!validSource) {
        return;
      }

      if (
        event.data?.type ===
        'proxium:dashboard-ready'
      ) {
        fit();

        timers.push(
          window.setTimeout(
            revealDemo,
            80
          )
        );

        return;
      }

      if (
        event.data?.type ===
          'proxium:appsheet' &&
        event.data?.action ===
          'open'
      ) {
        setPhoneVisible(true);
      }

      if (
        event.data?.type ===
          'proxium:appsheet' &&
        event.data?.action ===
          'close'
      ) {
        setPhoneVisible(false);
      }
    };

    on(
      window,
      'message',
      handleMessage
    );

    on(
      document,
      'keydown',
      (event) => {
        if (
          event.key ===
          'Escape'
        ) {
          setPhoneVisible(false);
        }
      }
    );

    if (dashboardFrame) {
      on(
        dashboardFrame,
        'load',
        () => {
          fit();

          timers.push(
            window.setTimeout(
              revealDemo,
              140
            )
          );
        },
        {
          once:true
        }
      );

      try {
        if (
          dashboardFrame
            .contentDocument
            ?.readyState ===
          'complete'
        ) {
          fit();

          timers.push(
            window.setTimeout(
              revealDemo,
              140
            )
          );
        }
      } catch (error) {
        /*
          El evento load se encargará
          de revelar la demo.
        */
      }
    } else {
      revealDemo();
    }

    /*
      Protección para que la pantalla
      de carga nunca quede bloqueada.
    */

    timers.push(
      window.setTimeout(
        revealDemo,
        6000
      )
    );

    const initialiseNavigation =
      () => {
        frames().forEach(
          (frame) => {
            const apply = () =>
              openDashboardPage(
                frame,
                0
              );

            if (!apply()) {
              on(
                frame,
                'load',
                apply,
                {
                  once:true
                }
              );
            }
          }
        );

        setActive(0);
      };

    let resizeObserver;

    if (
      'ResizeObserver' in window
    ) {
      resizeObserver =
        new ResizeObserver(fit);

      resizeObserver.observe(
        root
      );
    } else {
      on(
        window,
        'resize',
        fit
      );
    }

    fit();
    initialiseNavigation();

    root._proxiumCleanup = () => {
      timers.forEach(
        (timer) => {
          window.clearTimeout(
            timer
          );
        }
      );

      listeners.forEach(
        (remove) => {
          remove();
        }
      );

      if (resizeObserver) {
        resizeObserver.disconnect();
      }

      delete root._proxiumCleanup;
      delete root.dataset
        .proxiumReady;
    };
  }

  const initAll = (
    scope = document
  ) => {
    scope
      .querySelectorAll(selector)
      .forEach(init);
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAll();
      }
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      event.target
        .querySelectorAll(
          selector
        )
        .forEach((root) => {
          root
            ._proxiumCleanup?.();
        });
    }
  );
})();